export default {
  order: state => state.order,
  warehouseReport: state => state.warehouseReport
}
